<div class="container my-5">
    <h1>FAIRE UN DON</h1>
    <p>
        BONJOUR TOUS LE MONDE,
        THE COVID-19-TN a été un énorme succès ces derniers jours, il a maintenant atteint 3 millions d'utilisateurs et nous collectons des dons afin que nous puissions maintenir nos frais payés
        nous comptons sur vous ❤ .</p>

    <p>Des milliers de personnes comme vous nous aident à défendre contre COVID-19. Nous comptons sur vos dons pour achever notre mission.</p>

    <div class="donation method text-center">
        <img src="https://lh3.googleusercontent.com/lOgvUGpz6YUSXJG48kbzGrTEohIC8FDr_WkP6rwgaELR0g5o6OQu5-VPGexKoB8F0C-_" width="150px">
        <p>Faire un don en utilisant l'application D17 de la poste tunisienne</p>
        <p>numéro de bénéficiaire ( 93 863 732 )</p>
    </div>

    <div class="donation method text-center">
        <img src="https://webmedia-tunisie.com/wp-content/uploads/2018/04/Carte-e-dinar-paiement-en-ligne-site-e-commerce-Web-Media-Tunisie.png" width="150px">
        <p>Faire un don directement sur la carte e-dinar</p>
        <p>numéro de carte ( 5359 4017 0513 4100 )</p>
    </div>

    
</div>